import React from 'react';
import { X, CheckCircle, Gift, Users, MapPin } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const ThankYouModal = ({ isOpen, onClose, userName }) => {
  const { teamColors } = useTheme();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className="relative w-full max-w-2xl mx-auto">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 p-2 rounded-full bg-white bg-opacity-20 hover:bg-opacity-30 transition-all duration-200"
        >
          <X size={24} className="text-white" />
        </button>

        {/* Main modal content */}
        <div 
          className="relative overflow-hidden rounded-2xl shadow-2xl"
          style={{
            background: `linear-gradient(135deg, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`
          }}
        >
          {/* Ticket-style design */}
          <div className="relative">
            {/* Perforated line effect */}
            <div className="absolute left-0 top-0 bottom-0 w-1 flex flex-col">
              {Array.from({ length: 20 }).map((_, i) => (
                <div
                  key={i}
                  className="w-1 h-2 bg-white rounded-full mx-auto my-1 opacity-60"
                  style={{ animationDelay: `${i * 0.1}s` }}
                />
              ))}
            </div>

            {/* Ticket stub section */}
            <div className="absolute left-0 top-0 bottom-0 w-24 bg-gray-800 flex flex-col items-center justify-center">
              <div className="text-white text-xs text-center space-y-1">
                <div>Gate 01</div>
                <div>Row 02</div>
                <div>Seat 03</div>
              </div>
            </div>

            {/* Main content area */}
            <div className="ml-24 p-8 text-white">
              {/* Background pattern */}
              <div className="absolute inset-0 opacity-10">
                <div className="absolute inset-0 bg-gradient-to-br from-white to-transparent"></div>
                <div className="absolute top-4 right-4 w-32 h-32 bg-white rounded-full opacity-20"></div>
                <div className="absolute bottom-4 left-4 w-24 h-24 bg-white rounded-full opacity-15"></div>
              </div>

              <div className="relative z-10">
                {/* Main message */}
                <h2 className="text-3xl font-bold mb-2">
                  THANK YOU FOR SUBSCRIBING!
                </h2>
                <p className="text-lg mb-6 opacity-90">
                  Welcome to the 40 Bags Community, {userName || 'Champion'}! 🏈
                </p>

                {/* Benefits list */}
                <div className="space-y-3 mb-6">
                  <div className="flex items-center space-x-3">
                    <Gift className="w-5 h-5 text-yellow-300" />
                    <span>Create your most unforgettable experiences!</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <MapPin className="w-5 h-5 text-blue-300" />
                    <span>All of your booking in one place!</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Users className="w-5 h-5 text-green-300" />
                    <span>Making it easy for you to "Connect to FUN!"</span>
                  </div>
                </div>

                {/* Ticket price section */}
                <div className="flex justify-between items-center">
                  <div className="text-sm opacity-80">
                    Check your inbox for your welcome guide!
                  </div>
                  <div className="text-right">
                    <div className="text-xs opacity-70">TICKET PRICE:</div>
                    <div className="text-2xl font-bold">$ FREE</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ThankYouModal;
